import {get } from "./cpdAxios";

/**
 * 获取菜单列表
 * @param {*} p 
 * @returns 
 */
export const getMenuList = (p) => get(`/common/menus`, p);